import React from "react";

type Tab = {
  id: string;
  label: string;
};

export interface TabGPTProps {
  activeTab: string;
  tabs: Tab[];
  setActiveTab: (id: string) => void;
}

const TabGPT: React.FC<TabGPTProps> = ({ activeTab, tabs, setActiveTab }) => {
  return (
    <div className="w-full border-b border-gray-200">
      <div className="flex flex-row ">
        {tabs
          .filter((tab) => tab)
          .map((tab, index) => (
            <div key={index} className="flex flex-row gap-4">
              <button
                id={tab.id}
                className={`px-0 py-2 text-sm font-medium border-b-2 transition-colors duration-200 ${
                  activeTab === tab.id
                    ? "border-black text-black"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
              <div className="border-b-2 w-4 border-transparent"></div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default TabGPT;
